import type { Observable } from 'rxjs';

import { InjectionToken } from '@angular/core';

export const CcoService = new InjectionToken<CcoServiceModel>('CcoService');

export interface CcoServiceModel {
  getCcoImages: () => Observable<string[]>;
}
